import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AlbumList from './album_list';
import AlbumDetail from './album_detail';

class Album extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <AlbumList/>;
    }else{
      if(params.id===undefined){
        view = <AlbumDetail/>;
      }else{
        view = <AlbumDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Album.contextTypes = {
  router: PropTypes.object
};

export default Album;
